import { useCallback } from 'react'

import { MediaInfoDialog } from '@/components/shared/media-info-dialog'
import { Label } from '@/components/ui/label'
import { db, type StoredExternalVideo } from '@/lib/db'

type VideoInfoDialogProps = {
  video: StoredExternalVideo | null
  onClose: () => void
  onSaved: () => void
}

const handleUpdate = async (id: string, changes: { title: string; memo: string }) => {
  await db.externalVideos.update(id, changes)
}

export const VideoInfoDialog = ({ video, onClose, onSaved }: VideoInfoDialogProps) => {
  const renderExtraFields = useCallback(
    (item: StoredExternalVideo) => (
      <>
        {item.quality && (
          <div>
            <Label className="text-xs text-muted-foreground">画質</Label>
            <p className="text-sm">
              {item.quality === 'high' && '高画質'}
              {item.quality === 'medium' && '中画質 (720p)'}
              {item.quality === 'low' && '低画質 (480p)'}
            </p>
          </div>
        )}
      </>
    ),
    [],
  )

  return (
    <MediaInfoDialog
      item={video}
      dialogTitle="動画情報"
      onUpdate={handleUpdate}
      onClose={onClose}
      onSaved={onSaved}
      renderExtraFields={renderExtraFields}
    />
  )
}
